import { useState } from "react";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [toast, setToast] = useState("");

  const copyLink = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setToast("链接已复制到剪贴板");
    } catch {
      setToast(`分享链接：${url}`);
    }
    window.setTimeout(() => setToast(""), 2200);
  };

  const social = (name: string) => {
    setToast(`已将《${title}》分享到${name}（演示）`);
    window.setTimeout(() => setToast(""), 2200);
  };

  return (
    <div className="relative flex items-center gap-2">
      <button
        type="button"
        onClick={copyLink}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
      >
        <i className="ri-link" />
        复制链接
      </button>
      <button
        type="button"
        aria-label="分享到微博"
        onClick={() => social("微博")}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
      >
        <i className="ri-weibo-fill" />
      </button>
      <button
        type="button"
        aria-label="分享到微信"
        onClick={() => social("微信")}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
      >
        <i className="ri-wechat-fill" />
      </button>
      <button
        type="button"
        aria-label="分享到QQ"
        onClick={() => social("QQ")}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600 cursor-pointer"
      >
        <i className="ri-qq-fill" />
      </button>

      {toast && (
        <div className="absolute left-0 top-full z-20 mt-2 animate-fade-in whitespace-nowrap rounded-md bg-foreground-950 px-3 py-2 text-xs text-background-50">
          {toast}
        </div>
      )}
    </div>
  );
}